var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCoupon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2 5.84331C2 4.78236 2 4.25188 2.19616 3.84225C2.39315 3.43088 2.72483 3.0992 3.1362 2.90221C3.54583 2.70605 4.0763 2.70605 5.13725 2.70605H10.8627C11.9237 2.70605 12.4542 2.70605 12.8638 2.90221C13.2752 3.0992 13.6069 3.43088 13.8038 3.84225C14 4.25188 14 4.78236 14 5.84331V6.07257C14 6.16254 13.9271 6.23547 13.8371 6.23547H13.6212C12.6609 6.23547 11.8824 7.01396 11.8824 7.97429V7.97429C11.8824 8.95459 12.6923 9.74111 13.6722 9.71236L13.8371 9.70752C13.9263 9.7049 14 9.77649 14 9.86571V10.1123C14 11.2154 14 11.767 13.7884 12.1896C13.595 12.576 13.2817 12.8893 12.8953 13.0827C12.4727 13.2943 11.9211 13.2943 10.818 13.2943H5.13725C4.0763 13.2943 3.54583 13.2943 3.1362 13.0981C2.72483 12.9011 2.39315 12.5695 2.19616 12.1581C2 11.7485 2 11.218 2 10.157V9.92777C2 9.83781 2.07293 9.76488 2.1629 9.76488H2.35294C3.32756 9.76488 4.11765 8.97479 4.11765 8.00017V8.00017C4.11765 7.02555 3.32756 6.23547 2.35294 6.23547H2.1629C2.07293 6.23547 2 6.16254 2 6.07257V5.84331Z",
    stroke: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.05884 2.82324V3.44824M9.05884 5.94824V6.57324M9.05884 9.07324V9.69824M9.05884 12.1982V12.8232",
    stroke: "white",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCoupon);
export default __webpack_public_path__ + "static/media/icon_coupon.f520693f34b8c7538dc570b8a97636b5.svg";
export { ForwardRef as ReactComponent };